// 项目通用域名配置
export const HOSTUrls = {
	HOST: {
		prod: '//mini-platform-gateway.hortorgames.com/mini-platform-gateway',
		test:
			'//mini-platform-gateway-test.hortorgames.com/mini-platform-gateway',
		dev:
			'//mini-platform-gateway-test.hortorgames.com/mini-platform-gateway',
	},
	UploadHOST:{
		prod: '//platform.hortorgames.com/customer',
		test: '//platform-test.hortorgames.com/customer',
		dev: '//platform-dev.hortorgames.com/customer',
	},
	NewHOST:{
		prod: 'https://background-pub.hortorgames.com',
		test: 'https://background-pub-test.hortorgames.com',
		dev: 'https://background-pub-dev.hortorgames.com',
	}
};
